{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0, 1, 2, 3, 4, 5]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cube",
			"rotation": [0.08554723113775253, -0.7019128799438477, 0.08554724603891373, 0.7019128799438477],
			"scale": [0.810787558555603, 0.16301321983337402, 1.0850619077682495],
			"translation": [-0.0606195442378521, 0.8560767769813538, -0.3259848654270172]
		},
		{
			"mesh": 1,
			"name": "Cylinder",
			"rotation": [-0.08554711937904358, 0.7019128799438477, -0.7019128799438477, 0.08554735034704208],
			"scale": [0.19984979927539825, 0.13605819642543793, 0.19984979927539825],
			"translation": [0.801461935043335, 0.7026734352111816, -1.025984764099121]
		},
		{
			"mesh": 2,
			"name": "Cylinder.001",
			"rotation": [-0.08554711937904358, 0.7019128799438477, -0.7019128799438477, 0.08554735034704208],
			"scale": [0.19984979927539825, 0.13605819642543793, 0.19984979927539825],
			"translation": [-0.7517006993293762, 0.31837451457977295, -1.0251679420471191]
		},
		{
			"mesh": 3,
			"name": "Cylinder.002",
			"rotation": [-0.08554711937904358, 0.7019128799438477, -0.7019128799438477, 0.08554735034704208],
			"scale": [0.19984979927539825, 0.13605819642543793, 0.19984979927539825],
			"translation": [0.8014618754386902, 0.7026734352111816, 0.374015212059021]
		},
		{
			"mesh": 4,
			"name": "Cylinder.003",
			"rotation": [-0.08554711937904358, 0.7019128799438477, -0.7019128799438477, 0.08554735034704208],
			"scale": [0.19984979927539825, 0.13605819642543793, 0.19984979927539825],
			"translation": [-0.7517008185386658, 0.31837451457977295, 0.37401509284973145]
		},
		{
			"mesh": 5,
			"name": "Cube.001",
			"rotation": [0, -0.7071068286895752, 0, 0.7071068286895752],
			"scale": [1, 0.5095108151435852, 1.6508198976516724],
			"translation": [-0.03808618709445, -1.018710970878601, -0.3259848654270172]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.067",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.042004480957984924, 0.16293717920780182, 0.531399130821228, 1],
				"metallicFactor": 0.5826771855354309,
				"roughnessFactor": 0.4330708384513855
			}
		},
		{
			"doubleSided": true,
			"name": "Material.023",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.07979452610015869, 0.10829390585422516, 0.14765533804893494, 1],
				"metallicFactor": 0.6850393414497375,
				"roughnessFactor": 0.26377952098846436
			}
		},
		{
			"doubleSided": true,
			"name": "Material.066",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.10183504223823547, 0.08647964149713516, 0.06785748898983002, 1],
				"metallicFactor": 0
			}
		}
	],
	"meshes": [
		{
			"name": "Cube",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				}
			]
		},
		{
			"name": "Cylinder",
			"primitives": [
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 1
				}
			]
		},
		{
			"name": "Cylinder.001",
			"primitives": [
				{
					"attributes": {
						"POSITION": 8,
						"NORMAL": 9,
						"TEXCOORD_0": 10
					},
					"indices": 7,
					"material": 1
				}
			]
		},
		{
			"name": "Cylinder.002",
			"primitives": [
				{
					"attributes": {
						"POSITION": 11,
						"NORMAL": 12,
						"TEXCOORD_0": 13
					},
					"indices": 7,
					"material": 1
				}
			]
		},
		{
			"name": "Cylinder.003",
			"primitives": [
				{
					"attributes": {
						"POSITION": 14,
						"NORMAL": 15,
						"TEXCOORD_0": 16
					},
					"indices": 7,
					"material": 1
				}
			]
		},
		{
			"name": "Cube.001",
			"primitives": [
				{
					"attributes": {
						"POSITION": 17,
						"NORMAL": 18,
						"TEXCOORD_0": 19
					},
					"indices": 20,
					"material": 2
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 154,
			"max": [1.271138072013855, 8.94529914855957, 1.5344587564468384],
			"min": [-1.2670235633850098, -1, -1.5408854484558105],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 154,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 154,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 300,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 192,
			"max": [1, 1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 192,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 192,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 372,
			"type": "SCALAR"
		},
		{
			"bufferView": 8,
			"componentType": 5126,
			"count": 192,
			"max": [1, 1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 9,
			"componentType": 5126,
			"count": 192,
			"type": "VEC3"
		},
		{
			"bufferView": 10,
			"componentType": 5126,
			"count": 192,
			"type": "VEC2"
		},
		{
			"bufferView": 11,
			"componentType": 5126,
			"count": 192,
			"max": [1, 1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 12,
			"componentType": 5126,
			"count": 192,
			"type": "VEC3"
		},
		{
			"bufferView": 13,
			"componentType": 5126,
			"count": 192,
			"type": "VEC2"
		},
		{
			"bufferView": 14,
			"componentType": 5126,
			"count": 192,
			"max": [1, 1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 15,
			"componentType": 5126,
			"count": 192,
			"type": "VEC3"
		},
		{
			"bufferView": 16,
			"componentType": 5126,
			"count": 192,
			"type": "VEC2"
		},
		{
			"bufferView": 17,
			"componentType": 5126,
			"count": 497,
			"max": [1.768776297569275, 3.2164299488067627, 1.2332539558410645],
			"min": [-1.5211164951324463, -1, -1.4111268520355225],
			"type": "VEC3"
		},
		{
			"bufferView": 18,
			"componentType": 5126,
			"count": 497,
			"type": "VEC3"
		},
		{
			"bufferView": 19,
			"componentType": 5126,
			"count": 497,
			"type": "VEC2"
		},
		{
			"bufferView": 20,
			"componentType": 5123,
			"count": 1056,
			"type": "SCALAR"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 1848,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1848,
			"byteOffset": 1848,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1232,
			"byteOffset": 3696,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 600,
			"byteOffset": 4928,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 2304,
			"byteOffset": 5528,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2304,
			"byteOffset": 7832,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1536,
			"byteOffset": 10136,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 744,
			"byteOffset": 11672,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 2304,
			"byteOffset": 12416,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2304,
			"byteOffset": 14720,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1536,
			"byteOffset": 17024,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2304,
			"byteOffset": 18560,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2304,
			"byteOffset": 20864,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1536,
			"byteOffset": 23168,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2304,
			"byteOffset": 24704,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2304,
			"byteOffset": 27008,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1536,
			"byteOffset": 29312,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 5964,
			"byteOffset": 30848,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 5964,
			"byteOffset": 36812,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 3976,
			"byteOffset": 42776,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2112,
			"byteOffset": 46752,
			"target": 34963
		}
	],
	"buffers": [
		{
			"byteLength": 48864,
			"uri": "minecart.bin"
		}
	]
}
